import { NoRefError } from "../no-ref-error.js";
import entryItemRefIsElement from "./entry-item-ref-is-element.js";
const ensureRefPassed = entry => {
  if (entryItemRefIsElement(entry)) {
    return entry;
  }
  throw new NoRefError();
};
export default ensureRefPassed;